module.exports = __webpack_public_path__ + "img/logo-small-white.772c15e0.png";